import { useTranslation } from 'react-i18next';
import FileAppPicture from '@/assets/images/file-app.png?w=24&format=avif;webp&as=picture';
import PicturizedImage from '@/components/common/picturized-image';
import { ConversationMessageContentType, type ConversationMessageTypeUnion } from '@/models/conversations/conversation';
import { makePrompt } from '@/stores/prompter';
import { getMessageDownloadParams } from '@/utils/get-message-downloadable';
import useDownloadUrl from './use-download-url';
import useUserPlatform from './use-user-platform';

export default function useDownloadMessageFile(message?: Pick<ConversationMessageTypeUnion, 'Message' | 'MsgType'>) {
  const { t } = useTranslation();
  const { isIOS } = useUserPlatform();
  const { handleDownloadUrl, isLoading: isDownloading } = useDownloadUrl();
  const handleDownload = () => {
    if (!message) return;

    const params = getMessageDownloadParams(message);
    if (!params) return;

    if (message.MsgType === ConversationMessageContentType.File && isIOS) {
      handlePromptDownload(() => handleDownloadUrl(params.url, params.type, params.key)).catch(console.warn);
    } else {
      handleDownloadUrl(params.url, params.type, params.key).catch(console.warn);
    }
  };

  const handlePromptDownload = async (callback: () => Promise<void>) => {
    await makePrompt({
      key: 'download-file',
      type: 'dialog',
      title: '',
      content: (
        <div className='flex items-center justify-center gap-1.5'>
          {t('common.download.media-hint')}
          <PicturizedImage
            picture={FileAppPicture}
            className='size-6'
          />
        </div>
      ),
      resolveButtonLabel: t('common.download.confirm'),
      promise: callback,
    });
  };
  return {
    handleDownload,
    isDownloading,
  };
}
